export default {
    getJsonScript(elementId, defaultValue = {}) {
        try {
            return JSON.parse(document.getElementById(elementId).innerHTML)
        } catch {
            return defaultValue
        }
    },
    excludeCheckbox(event) {
        const el = event.target
        const rowEl = el.closest("tr")
        if (event.target.checked) {
            rowEl.classList.add("excluded")
        } else {
            rowEl.classList.remove("excluded")
        }
    },
    includeCheckbox(event) {
        const el = event.target
        const rowEl = el.closest("tr")
        if (event.target.checked) {
            rowEl.classList.remove("excluded")
        } else {
            rowEl.classList.add("excluded")
        }
    },
    getFilesize(inputEl) {
        if (inputEl.files && inputEl.files.length) {
            return inputEl.files[0].size
        }
        return 0
    },
}